import { render, staticRenderFns } from "./new-progress-bar.vue?vue&type=template&id=0eb315b4&scoped=true"
import script from "./new-progress-bar.vue?vue&type=script&lang=js"
export * from "./new-progress-bar.vue?vue&type=script&lang=js"
import style0 from "./new-progress-bar.vue?vue&type=style&index=0&id=0eb315b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb315b4",
  null
  
)

export default component.exports